/**
 * Profile data for the business card site. All identifiers (X handle, blog
 * domain, employer, hometown, birth year) come from publicly available sources.
 * The mail address is a placeholder — replace before launch.
 */

export interface ProfileLink {
  key: string;
  iconId: string;
  label: string;
  url: string;
  handle: string;
  description: string;
}

export interface PortfolioItem {
  title: string;
  year: string;
  tag: string;
  url?: string;
  blurb?: string;
}

export interface HistoryEntry {
  year: string;
  description: string;
}

export interface Profile {
  name: { ja: string; kana: string; en: string };
  handle: string;
  role: string;
  affiliation: string;
  location: string;
  yearOfBirth: number;
  bio: string[];
  history: HistoryEntry[];
  skills: string[];
  links: ProfileLink[];
  portfolio: PortfolioItem[];
  domain: string;
  mail: string;
}

export const profile: Profile = {
  name: { ja: "齋藤 公一", kana: "サイトウ マサカズ", en: "Saito Masakazu" },
  handle: "@31mskz10",
  role: "フロントエンドエンジニア",
  affiliation: "N'sCreates株式会社",
  location: "兵庫県神戸市",
  yearOfBirth: 1997,
  domain: "business-card.31mskz10.com",
  mail: "hello [at] webrandum.net",
  bio: [
    "兵庫・神戸を拠点に開発をしているフロントエンドエンジニアです。" +
      "元々ウェブデザインの勉強をしていました。" +
      "その後コーダーとして制作業務に関わり、" +
      "現在はフロントエンドを中心にしつつ、バックエンドからインフラまで広く学習を進めています。",
    "Macの作業効率化やライフハックが好きで、" +
      "個人ブログの「Webrandum」では、試行錯誤した内容を備忘録として公開しています。",
  ],
  history: [
    { year: "1997", description: "兵庫県生まれ。" },
    { year: "2016", description: "デザイン専門学校に入学、Web デザインを学び始める。" },
    { year: "2018", description: "卒業後、神戸の制作会社 N's Creates に Web デザイナーとして入社。" },
    { year: "2019", description: "CSS Nite Best 20 Session に登壇、年間ベスト 20 に選出。" },
    { year: "now", description: "「Webrandum」で備忘録を継続的に公開しつつ、案件のデザイン / 実装を担当。" },
  ],
  skills: [
    "Web Design",
    "Front-end (HTML / CSS / TypeScript)",
    "Tailwind CSS",
    "Figma",
    "Technical Writing",
  ],
  links: [
    {
      key: "X",
      iconId: "ic-x",
      label: "X / Twitter",
      url: "https://x.com/31mskz10",
      handle: "@31mskz10",
      description: "日々の制作で気づいたこと・実験の途中経過をつぶやいています。",
    },
    {
      key: "Web",
      iconId: "ic-webrandum",
      label: "Webrandum",
      url: "https://webrandum.net/",
      handle: "webrandum.net",
      description: "Web 制作の備忘録ブログ。テーマも実装も運用も全部自分でやっています。",
    },
    {
      key: "Note",
      iconId: "ic-note",
      label: "note",
      url: "https://note.com/31mskz10",
      handle: "note.com/31mskz10",
      description: "テキストでじっくり書きたい話を載せています。",
    },
    {
      key: "FB",
      iconId: "ic-facebook",
      label: "Facebook",
      url: "https://www.facebook.com/webrandum/",
      handle: "facebook.com/webrandum",
      description: "古いつながり用に。最近はあまり触っていません。",
    },
    {
      key: "Mail",
      iconId: "ic-mail",
      label: "Mail",
      url: "mailto:31mskz10@gmail.com",
      handle: "31mskz10@gmail.com",
      description: "お仕事のご相談・お問い合わせはこちらから。",
    },
  ],
  portfolio: [
    {
      title: "Webrandum",
      year: "2017–",
      tag: "Personal Blog",
      url: "https://webrandum.net/",
      blurb: "作業効率化とウェブ制作の備忘録。テーマ・実装・運用すべて自分で。",
    },
    {
      title: "CSS Nite 2019 Session",
      year: "2019",
      tag: "Speaking",
      blurb: "年間ベスト 20 セッションに選出された登壇プロジェクト。",
    },
    {
      title: "Client Works @ N's Creates",
      year: "2019–",
      tag: "Production",
      blurb: "神戸の制作会社で手がける Web デザイン / 実装案件。",
    },
    {
      title: "Business Card Site",
      year: "2026",
      tag: "Experiment",
      url: "https://business-card.31mskz10.com/",
      blurb: "HTML in Canvas を使った浮遊する 3D 名刺サイト。本サイト。",
    },
  ],
};
